
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/approval-process.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-approval-process-demo-end","docs-flow-components-approval-process-demo-processing"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/approval-process.md?type=demo')
};